import styled from 'styled-components';

export const PSAPageContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0px 48px;
    padding-bottom: 48px;
    width: 100%;
`;
export const BtnContainer = styled.div`
    display: flex;
    gap: 12px;
`;